// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const flexBoxStyles = "Scrollable__flexBoxStyles__ygaTG";
export const customScroll = "Scrollable__customScroll__z9jja";
export const outerContainer = "Scrollable__outerContainer__+Tm0q";
export const innerContainer = "Scrollable__innerContainer__C1hgg";
export const flexBox = "Scrollable__flexBox__bzrWX";
export const scrollHandleDragged = "Scrollable__scrollHandleDragged__j3qqh";
export const customScrollbar = "Scrollable__customScrollbar__eoxwr";
export const fadeTop = "Scrollable__fadeTop__51PYQ";
export const fadeBottom = "Scrollable__fadeBottom__9F4WE";
export const contentScrolled = "Scrollable__contentScrolled__BAuDr";
export const customScrollbarShownAlways = "Scrollable__customScrollbarShownAlways__nUSiD";
export const customScrollHandle = "Scrollable__customScrollHandle__A6NhJ";
export const innerHandle = "Scrollable__innerHandle__s6CkV";